import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  Box, 
  Typography, 
  Button, 
  IconButton 
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

/**
 * 이메일 인증 차단 모달 컴포넌트
 */
const EmailVerificationBlockModal = ({ 
  open,
  onClose,
  userEmail,
  onResendVerification,
  isResending = false 
}) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2
        }
      }}
    >
      {/* 닫기 버튼 */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#666',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ textAlign: 'center', pt: 0 }}>
        {/* 이메일 아이콘 */}
        <Box sx={{ mb: 3 }}>
          <EmailIcon 
            sx={{ 
              fontSize: 64, 
              color: '#ff6b6b',
              mb: 2 
            }} 
          />
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#333' }}>
            {t('emailVerification.blockModal.title')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            {t('emailVerification.blockModal.subtitle')}
          </Typography>
        </Box>

        {/* 안내 메시지 */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="body2" color="text.secondary" paragraph>
            {t('emailVerification.blockModal.description', { email: userEmail })}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t('emailVerification.blockModal.spamNotice')}
          </Typography>
        </Box>

        {/* 재발송 버튼 */}
        <Button
          variant="contained"
          size="large"
          startIcon={<RefreshIcon />}
          onClick={onResendVerification}
          disabled={isResending}
          fullWidth
          sx={{
            bgcolor: '#4dabf7',
            py: 1.5,
            '&:hover': {
              bgcolor: '#339af0'
            }
          }}
        >
          {isResending ? t('emailVerification.resending') : t('emailVerification.blockModal.resendButton')}
        </Button>

        {/* 도움말 */}
        <Box sx={{ mt: 3, p: 2, bgcolor: '#e3f2fd', borderRadius: 2 }}>
          <Typography variant="body2" color="text.secondary">
            💡 {t('emailVerification.blockModal.helpText')}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EmailVerificationBlockModal; 